/* unplugin-vue-components disabled */import script from "./EditPrizePriceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPrizePriceModal.vue?vue&type=script&setup=true&lang=js"

import "./EditPrizePriceModal.vue?vue&type=style&index=0&id=1efb2772&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1efb2772"]])

export default __exports__